import backend from "../../../backend/backend";
import label from "../../../i18n/label";
import Notify from "../../shared/Notify";
import McpServerActions from "./mcpServerActions";

export const loadPublicMcpServers = (intl, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .getPublicMcpServers()
      .then((data) => {
        console.log("loaded public mcp servers", data);
        dispatch({
          type: McpServerActions.PUBLIC_SERVER_LIST_LOADED,
          servers: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to load public mcp servers", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};
